import React, { useState } from "react";
import { db, paths } from "../firebase/config";
import { updateDoc, doc } from "firebase/firestore";
import { logAuditoria } from "../context/AuthContext";
import { Modal } from "./Modal";
import { Button } from "./Button";

export const ChangePasswordModal = ({ show, onClose, userProfile }) => {
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (novaSenha.length < 6) {
      setError("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }
    if (novaSenha !== confirmaSenha) {
      setError("As senhas não coincidem.");
      return;
    }

    setProcessing(true);
    try {
      const userRef = doc(db, paths.users, userProfile.id);
      await updateDoc(userRef, { senha: novaSenha });
      await logAuditoria(userProfile, "Alteração de Senha");
      setSuccess("Senha alterada com sucesso!");
      setNovaSenha("");
      setConfirmaSenha("");
      setTimeout(onClose, 1500);
    } catch (err) {
      setError("Falha ao alterar a senha. Tente novamente.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose} title="Alterar Senha">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Nova Senha
          </label>
          <input
            type="password"
            value={novaSenha}
            onChange={(e) => setNovaSenha(e.target.value)}
            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Confirmar Nova Senha
          </label>
          <input
            type="password"
            value={confirmaSenha}
            onChange={(e) => setConfirmaSenha(e.target.value)}
            className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            required
          />
        </div>

        {error && <p className="text-red-600 text-sm">{error}</p>}
        {success && <p className="text-green-600 text-sm">{success}</p>}

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button onClick={onClose} variant="secondary" disabled={processing}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={processing}>
            {processing ? "Salvando..." : "Salvar Nova Senha"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
